// extracted by css-extract-rspack-plugin
export default {"Heading":"ErrorPage-module__Heading__seAzU","Status":"ErrorPage-module__Status__qiBNt","Message":"ErrorPage-module__Message__zz8Qu"};